<div class="planogram-wrapper" *ngIf="masterPlanogramData.length">
    <div class="lane-wrapper" *ngFor="let lane of masterPlanogramData, let i=index">

        <div class="lane-tag flexc-column">
            <div class="d-flex  align-items-center position-relative ">
                <div class="btnX plano-btn cursor" [style.color]="'#4D8DA4'" (click)="navigationToSite()">
                    {{lane?.zoneName}}</div>
                <!-- <span><button mat-raised-button color="primary"
                        (click)="tagMonotainers(lane?.zoneId)">Tag</button></span> -->
                <div class="ml-auto d-flex gap20">
                    <div class="d-flex align-items-center gap20 ">
                        <div mat-button (click)="tagMonotainers(lane?.zoneId, 'tag')"
                            class="d-grid m-0 px-0 justify-content-center w-100"><img
                                src="../../assets/images/Tag-monotainer.svg"
                                class="d-grid height30px cursor hover-color"
                                title="Tag monotainer to {{lane?.zoneName}}" alt="Tag"></div>


                        <div mat-button (click)="tagMonotainers(lane?.zoneId, 'untag',lane?.monotainers)"
                            class="d-grid m-0 px-0 justify-content-center w-100"><img
                                src="../../assets/images/Untag-monotainer.svg"
                                class="d-grid height30px cursor hover-color"
                                title="Untag monotainers tagged to {{lane?.zoneName}} but currently not inside the lane"
                                alt="Untag"></div>
                    </div>




                    <!-- <div [style.color]="lane.laneStatusColor" class="lane-status">Occupied</div> -->
                    <div class="d-flex flex-column align-items-center">
                        <!-- <img src="../../../../assets/images/bellIcon.svg" title="Alerts" alt="Alerts"
                            class="h-30 space-after-icon"> -->
                        <!-- <div class="label-container-border space-after-icon"
                            [ngClass]="false ? 'label-container-green' : 'label-container-red'">
                            Occupancy 100%
                        </div> -->
                        <span class=" text-center" [ngClass]="lane?.alerts?.length ? 'alert-count' : ''"
                            *ngIf="lane?.alerts?.length">{{lane?.alerts?.length}}</span>
                        <span class="cursor"
                            (click)="navigationToAlert(lane?.zoneId, 'laneId', lane?.zoneName, lane?.alerts?.[0]?.sourceTimestamp, lane?.alerts?.[lane?.alerts?.length -1]?.sourceTimestamp)">
                            <svg width="27" height="29" viewBox="0 0 21 23" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M2.99027 8.78296C2.98885 7.79965 3.18745 6.82578 3.57463 5.91745C3.9618 5.00912 4.52991 4.18427 5.24622 3.49041C5.96254 2.79656 6.81291 2.2474 7.74835 1.87458C8.68379 1.50176 9.68582 1.31264 10.6967 1.31811C14.9177 1.34921 18.2966 4.76023 18.2966 8.87627V9.61238C18.2966 13.3241 19.096 15.4806 19.7995 16.6625C19.8742 16.7884 19.9136 16.9312 19.9138 17.0765C19.9139 17.2219 19.8748 17.3647 19.8003 17.4907C19.7258 17.6167 19.6186 17.7214 19.4893 17.7944C19.3601 17.8675 19.2135 17.9062 19.064 17.9067H2.22282C2.0734 17.9062 1.92673 17.8675 1.79752 17.7944C1.66831 17.7214 1.56109 17.6167 1.4866 17.4907C1.41211 17.3647 1.37298 17.2219 1.37311 17.0765C1.37324 16.9312 1.41264 16.7884 1.48735 16.6625C2.19085 15.4806 2.99027 13.3241 2.99027 9.61238V8.78296Z"
                                    [ngClass]="lane?.alerts?.length ? 'bell-active' : 'bell-inactive'"
                                    stroke-width="1.55926" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M7.23273 17.9066V18.736C7.23273 19.616 7.59209 20.4598 8.23175 21.082C8.87141 21.7042 9.73899 22.0538 10.6436 22.0538C11.5482 22.0538 12.4158 21.7042 13.0555 21.082C13.6951 20.4598 14.0545 19.616 14.0545 18.736V17.9066"
                                    [ngClass]="lane?.alerts?.length ? 'bell-active' : 'bell-inactive'"
                                    stroke-width="1.55926" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </span>

                    </div>

                </div>
            </div>
            <div class="d-flex gp-20 plan-tile-parent-containner">
                <div class="planogram-tile-style">
                    <div>
                        <span class="pr-10">Destination:</span>
                        <span [matTooltip]="lane?.destination">{{lane?.destination}}</span>
                    </div>

                    <div>
                        <span class="pr-10">Active Tags:</span>
                        <span [matTooltip]="lane?.activeTags">{{lane?.activeTags}}</span>
                    </div>

                    <div *ngIf="lane?.outsideCount > 0">
                        <span class="pr-10">Outside:</span>
                        <span [matTooltip]="lane?.activeTags">{{lane?.outsideCount}}</span>
                    </div>

                </div>
                <div class="planogram-tile-style">
                    <div>
                        <span class="pr-10" matTooltip="Reported 1min ago" matTooltipPosition="above">Batch
                            Occupancy:</span>
                        <span title="{{lane?.occupancyPct? lane?.occupancyPct: 0}} %">{{lane?.occupancyPct?
                            lane?.occupancyPct: 0}}
                            <span>%</span></span>
                    </div>
                    <!-- <img alt="Info" class="image-size cursor"
                                src="../../../../assets/images/info-circle.svg"
                                [matTooltip]="toolTipMessage?.laneTat"> -->
                    <div>
                        <span class="pr-10" [matTooltip]="toolTipMessage?.laneTat">Average TAT:</span>
                        <span [matTooltip]="lane?.batchTat">{{lane?.batchTat}}</span>
                    </div>
                </div>

            </div>
            <div class="d-flex planogram monotainer-selector-box-border">
                <div class="monotainer-selector-box cursor" *ngFor="let item of lane?.laneFilter; let filterIndex=index"
                    [ngClass]="{'tile-selected': item?.isSelected}" (click)="ontileFilterChange(i,filterIndex)">
                    <div>{{item?.name}}</div>
                    <div>{{lane[item.key]}}</div>
                </div>
                <!-- <div class="monotainer-selector-box monotainer-selector-box-border cursor"
                    [ngClass]="{'tile-selected': item?.isSelected}" (click)="ontileFilterChange(2)">
                    <div>In Lane</div>
                    <div>0</div>
                </div>
                <div class="monotainer-selector-box cursor" [ngClass]="{'tile-selected': item?.isSelected}"
                    (click)="ontileFilterChange(3)">
                    <div>Missing</div>
                    <div>0</div>
                </div> -->
            </div>



        </div>
        <div class="lane-tag-dtls">
            <span class="monotainer-title-wrapper">
                <span class="monotainer-title-wrapper fd-column">
                    <span>{{getTitle(lane)}}</span><span class="pl-1">
                        <div *ngIf="false">
                            <div class="lbody">
                                <div id="parent-circle">
                                    <div class="circle teal"></div>
                                </div>
                            </div>
                        </div>
                    </span>
                </span>
                <div class="d-flex">
                    <!-- <span *ngIf="getStatus(lane?.laneFilter)" class="blinking live-text-color">
                        <img src="../../../assets/images/live-icon.svg" alt="live" title="Live">&nbsp;Live
                    </span> -->
                    <button class="btnX" (click)="resetLane(lane?.zoneName,lane?.zoneId)">
                        <img src="../../../../assets/images/refreshgreen.svg" title="Refresh lane"
                            class="refreshicon cursor mr-2">
                        <span class="cursor btn-color">
                            Lane Reset
                        </span>
                    </button>

                    <div class="d-flex" *ngIf="isTimerEnabled">
                        <mat-progress-spinner class="custom-spinner track" [diameter]="23" mode="determinate"
                            [value]="progressbarValue">
                        </mat-progress-spinner>
                        <div class="clock">
                            <div class="custom-loader-planogram">{{curSec}}
                            </div>
                        </div>

                    </div>
                </div>
            </span>
            <!-- {{i+1}} -->
            <div class="d-flex lane-in-out" *ngIf="false">
                <div>Lane In</div>
                <div>Lane Out</div>
            </div>
            <div class="d-flex">
                <div matTooltip="Lane In/Out" class="d-flex align-items-center">
                    <img alt="camera" src="../../../../assets/images/Entry-Exit.svg" class="mh-30">
                </div>
                <div class="w-100 stack">
                    <div class="make-responsive-planogramlist align-item-end"
                        *ngIf="lane?.monotainers?.length && lane?.stack>1" [ngClass]="lane?.stack>1 ? 'dotted' : ''">
                        <!-- <div *ngFor="let entity of lane?.laneDetails?.mappedEntities"
                    [ngClass]="{'fill-mono-red': entity?.category !== 'ISA','fill-mono-green': entity?.category === 'ISA'}">
                    {{entity?.entityName}}
                </div> -->
                        <ng-container *ngIf="lane?.monotainers | stateFilter : getFilterItem(lane?.laneFilter) as data">
                            <ng-container *ngIf="data.length">
                                <div *ngFor="let entity of data | stackFilter: 'upper': lane?.stack">
                                    <!-- [ngClass]="{'align-item-end': (entity?.stackPosition!==2 && lane?.stack>1),'mr-30': (entity?.stackPosition===2 && lane?.stack>1)}" -->
                                    <!-- <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M1 5.22535V16.7746L10.8592 21M1 5.22535L10.8592 9.4507M1 5.22535L6.07042 2.97183M10.8592 9.4507V21M10.8592 9.4507L15.9296 7.33803M10.8592 21L21 16.7746V5.22535M21 5.22535L15.9296 7.33803M21 5.22535L11.1408 1H10.8592L6.07042 2.97183M15.9296 7.33803L6.07042 2.97183"
                            [ngClass]="{'non-isa': entity?.category !== 'ISA','isa': entity?.category === 'ISA'}" />
                        <path
                            d="M15.9296 7.47888V7.76057M15.9296 11.7042V7.76057M15.9296 7.76057L11.1409 9.7324V20.4366H10.5775V9.7324M15.9296 7.76057L20.7184 5.78874M10.5775 9.7324L1.28174 5.50705V5.78874L10.5775 9.7324Z"
                            [ngClass]="{'non-isa': entity?.category !== 'ISA','isa': entity?.category === 'ISA'}" />
                    </svg> -->
                                    <div class="plan-hovr-gram position-relative d-flex flex-column">
                                        <div [matMenuTriggerFor]="monotainerPop" #popTrigger="matMenuTrigger"
                                            (click)="popTrigger.openMenu()" matTooltip="{{entity?.uniqueId}}"
                                            matTooltipPosition="above" class="cursor">
                                            <div class="mono-elipses"><span
                                                    class="mono-label">{{entity?.uniqueId}}</span></div>
                                            <svg width="39" height="39" viewBox="0 0 39 39" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <rect width="39" height="39" rx="4"
                                                    class="{{entity?.state}} {{entity?.state}}-background" />
                                                <path
                                                    d="M8 12.8592V26.1408L19.338 31M8 12.8592L19.338 17.7183M8 12.8592L13.831 10.2676M19.338 17.7183V31M19.338 17.7183L25.169 15.2887M19.338 31L31 26.1408V12.8592M31 12.8592L25.169 15.2887M31 12.8592L19.662 8H19.338L13.831 10.2676M25.169 15.2887L13.831 10.2676"
                                                    class="{{entity?.state}} {{entity?.state}}-background" />
                                                <path
                                                    d="M25.1688 15.4507V15.7747M25.1688 20.3099V15.7747M25.1688 15.7747L19.6618 18.0423V30.3521H19.0139V18.0423M25.1688 15.7747L30.6758 13.507M19.0139 18.0423L8.32373 13.1831V13.507L19.0139 18.0423Z"
                                                    class="{{entity?.state}} {{entity?.state}}-background" />
                                            </svg>
                                        </div><sup class="star-color ft-13" *ngIf="entity?.state==='untagged'">UT</sup>
                                        <!--popover stuff-->
                                        <ng-container>
                                            <mat-menu #monotainerPop="matMenu" [hasBackdrop]="true">
                                                <div class="pop-p-20" (click)="$event.stopPropagation()">
                                                    <div class="popClose">
                                                        <button type="button" aria-label="Close" class="close pmr-5"
                                                            (click)="popTrigger.closeMenu();">
                                                            <span aria-hidden="true">×</span></button>
                                                        <!-- <span class="cursor" (click)="popTrigger.closeMenu()">x</span> -->
                                                    </div>
                                                    <div class="d-flex mb-3">
                                                        <div class="plan-pop-head d-flex">
                                                            <span class="hyper cursor"
                                                                (click)="navigateToAsset(entity)">{{entity?.uniqueId}}</span><sup
                                                                class="{{entity?.state}} sup-cont no-hyper">{{getStateLabel(entity?.state)}}</sup>
                                                        </div>
                                                        <div
                                                            class="d-flex flex-column position-relative ml-auto align-items-center">
                                                            <span *ngIf="entity?.monotainerAlerts"
                                                                class="text-center alert-count">{{entity?.monotainerAlerts}}</span>
                                                            <div (click)="navigationToAlert(entity?.entityId, 'entityId')"
                                                                class="cursor ml-auto d-flex align-items-end">
                                                                <svg width="27" height="29" viewBox="0 0 21 23"
                                                                    fill="none" xmlns="http://www.w3.org/2000/svg"
                                                                    class="ml-auto">
                                                                    <path
                                                                        d="M2.99027 8.78296C2.98885 7.79965 3.18745 6.82578 3.57463 5.91745C3.9618 5.00912 4.52991 4.18427 5.24622 3.49041C5.96254 2.79656 6.81291 2.2474 7.74835 1.87458C8.68379 1.50176 9.68582 1.31264 10.6967 1.31811C14.9177 1.34921 18.2966 4.76023 18.2966 8.87627V9.61238C18.2966 13.3241 19.096 15.4806 19.7995 16.6625C19.8742 16.7884 19.9136 16.9312 19.9138 17.0765C19.9139 17.2219 19.8748 17.3647 19.8003 17.4907C19.7258 17.6167 19.6186 17.7214 19.4893 17.7944C19.3601 17.8675 19.2135 17.9062 19.064 17.9067H2.22282C2.0734 17.9062 1.92673 17.8675 1.79752 17.7944C1.66831 17.7214 1.56109 17.6167 1.4866 17.4907C1.41211 17.3647 1.37298 17.2219 1.37311 17.0765C1.37324 16.9312 1.41264 16.7884 1.48735 16.6625C2.19085 15.4806 2.99027 13.3241 2.99027 9.61238V8.78296Z"
                                                                        [ngClass]="entity?.monotainerAlerts ? 'bell-active' : 'bell-inactive'"
                                                                        stroke-width="1.55926" stroke-linecap="round"
                                                                        stroke-linejoin="round" />
                                                                    <path
                                                                        d="M7.23273 17.9066V18.736C7.23273 19.616 7.59209 20.4598 8.23175 21.082C8.87141 21.7042 9.73899 22.0538 10.6436 22.0538C11.5482 22.0538 12.4158 21.7042 13.0555 21.082C13.6951 20.4598 14.0545 19.616 14.0545 18.736V17.9066"
                                                                        [ngClass]="entity?.monotainerAlerts ? 'bell-active' : 'bell-inactive'"
                                                                        stroke-width="1.55926" stroke-linecap="round"
                                                                        stroke-linejoin="round" />
                                                                </svg>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="plano-pop-up-details">
                                                        <div class="d-flex plan-cont-hover">
                                                            <div>TagID :</div>
                                                            <div>{{entity?.tagId}}</div>
                                                        </div>
                                                        <div class="d-flex  plan-cont-hover">
                                                            <div>Tagged Time :</div>
                                                            <div>{{entity?.taggedTime | date:'hh:mm aaa':'en-US'}}</div>
                                                        </div>
                                                        <div class="d-flex  plan-cont-hover">
                                                            <div>Destination :</div>
                                                            <div>{{entity?.destination}}</div>
                                                        </div>
                                                        <div class="d-flex  plan-cont-hover">
                                                            <div>Lane Id :</div>
                                                            <div class="zone-name">
                                                                <div *ngFor="let zone of entity?.zones; let i=index">
                                                                    {{zone?.name}}
                                                                    <span
                                                                        *ngIf="i>0 && i < lane?.monotainers?.zones?.lenght-1">,</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex  plan-cont-hover">
                                                            <div>TAT :</div>
                                                            <div>{{entity?.tat}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="plano-timings">
                                                        <div class="border-right ">
                                                            <div class="plan-cont-hover">First Seen</div>
                                                            <div class="">{{entity?.firstSeen | date:'hh:mm
                                                                aaa':'en-US'}}</div>
                                                        </div>
                                                        <div class="border-right ">
                                                            <div class="plan-cont-hover">Entry Time</div>
                                                            <div class="">{{entity?.entryTime | date:'hh:mm
                                                                aaa':'en-US'}}</div>
                                                        </div>
                                                        <div>
                                                            <div class=" plan-cont-hover">Last Seen</div>
                                                            <div class="">{{entity?.lastSeen | date:'hh:mm
                                                                aaa':'en-US'}}</div>
                                                        </div>

                                                    </div>


                                                </div>
                                            </mat-menu>
                                        </ng-container>
                                    </div>

                                </div>
                                <!--popover stuff ends-->

                            </ng-container>
                        </ng-container>
                    </div>
                    <div *ngIf="lane?.monotainers?.length" class="monotainer-list"
                        [ngClass]="lane?.stack===1 ? 'align-items-center' : 'align-item-end'">
                        <!-- lower deck -->
                        <ng-container *ngIf="lane?.monotainers | stateFilter : getFilterItem(lane?.laneFilter) as data">
                            <ng-container>
                                <div *ngFor="let entity of data | stackFilter: 'lower': lane?.stack" class="ml-auto min-width-45">
                                    <div class="plan-hovr-gram position-relative d-flex flex-column min-height-70">
                                        <div [matMenuTriggerFor]="monotainerPop" #popTrigger="matMenuTrigger"
                                            (click)="popTrigger.openMenu()" matTooltip="{{entity?.uniqueId}}"
                                            matTooltipPosition="above" class="cursor">
                                            <div class="mono-elipses"><span
                                                    class="mono-label">{{entity?.uniqueId}}</span></div>
                                            <svg width="39" height="39" viewBox="0 0 39 39" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <rect width="39" height="39" rx="4"
                                                    class="{{entity?.state}} {{entity?.state}}-background" />
                                                <path
                                                    d="M8 12.8592V26.1408L19.338 31M8 12.8592L19.338 17.7183M8 12.8592L13.831 10.2676M19.338 17.7183V31M19.338 17.7183L25.169 15.2887M19.338 31L31 26.1408V12.8592M31 12.8592L25.169 15.2887M31 12.8592L19.662 8H19.338L13.831 10.2676M25.169 15.2887L13.831 10.2676"
                                                    class="{{entity?.state}} {{entity?.state}}-background" />
                                                <path
                                                    d="M25.1688 15.4507V15.7747M25.1688 20.3099V15.7747M25.1688 15.7747L19.6618 18.0423V30.3521H19.0139V18.0423M25.1688 15.7747L30.6758 13.507M19.0139 18.0423L8.32373 13.1831V13.507L19.0139 18.0423Z"
                                                    class="{{entity?.state}} {{entity?.state}}-background" />
                                            </svg>
                                        </div><sup class="star-color ft-13" *ngIf="entity?.state==='untagged'">UT</sup>
                                        <!--popover stuff-->
                                        <ng-container>
                                            <mat-menu #monotainerPop="matMenu" [hasBackdrop]="true">
                                                <div class="pop-p-20" (click)="$event.stopPropagation()">
                                                    <div class="popClose">
                                                        <button type="button" aria-label="Close" class="close pmr-5"
                                                            (click)="popTrigger.closeMenu();">
                                                            <span aria-hidden="true">×</span></button>
                                                        <!-- <span class="cursor" (click)="popTrigger.closeMenu()">x</span> -->
                                                    </div>
                                                    <div class="d-flex mb-3">
                                                        <div class="plan-pop-head d-flex">
                                                            <span class="hyper cursor"
                                                                (click)="navigateToAsset(entity)">{{entity?.uniqueId}}</span><sup
                                                                class="{{entity?.state}} sup-cont no-hyper">{{getStateLabel(entity?.state)}}</sup>
                                                        </div>
                                                        <div
                                                            class="d-flex flex-column position-relative ml-auto align-items-center">
                                                            <span *ngIf="entity?.monotainerAlerts"
                                                                class="text-center alert-count">{{entity?.monotainerAlerts}}</span>
                                                            <div (click)="navigationToAlert(entity?.entityId, 'entityId')"
                                                                class="cursor ml-auto d-flex align-items-end">
                                                                <svg width="27" height="29" viewBox="0 0 21 23"
                                                                    fill="none" xmlns="http://www.w3.org/2000/svg"
                                                                    class="ml-auto">
                                                                    <path
                                                                        d="M2.99027 8.78296C2.98885 7.79965 3.18745 6.82578 3.57463 5.91745C3.9618 5.00912 4.52991 4.18427 5.24622 3.49041C5.96254 2.79656 6.81291 2.2474 7.74835 1.87458C8.68379 1.50176 9.68582 1.31264 10.6967 1.31811C14.9177 1.34921 18.2966 4.76023 18.2966 8.87627V9.61238C18.2966 13.3241 19.096 15.4806 19.7995 16.6625C19.8742 16.7884 19.9136 16.9312 19.9138 17.0765C19.9139 17.2219 19.8748 17.3647 19.8003 17.4907C19.7258 17.6167 19.6186 17.7214 19.4893 17.7944C19.3601 17.8675 19.2135 17.9062 19.064 17.9067H2.22282C2.0734 17.9062 1.92673 17.8675 1.79752 17.7944C1.66831 17.7214 1.56109 17.6167 1.4866 17.4907C1.41211 17.3647 1.37298 17.2219 1.37311 17.0765C1.37324 16.9312 1.41264 16.7884 1.48735 16.6625C2.19085 15.4806 2.99027 13.3241 2.99027 9.61238V8.78296Z"
                                                                        [ngClass]="entity?.monotainerAlerts ? 'bell-active' : 'bell-inactive'"
                                                                        stroke-width="1.55926" stroke-linecap="round"
                                                                        stroke-linejoin="round" />
                                                                    <path
                                                                        d="M7.23273 17.9066V18.736C7.23273 19.616 7.59209 20.4598 8.23175 21.082C8.87141 21.7042 9.73899 22.0538 10.6436 22.0538C11.5482 22.0538 12.4158 21.7042 13.0555 21.082C13.6951 20.4598 14.0545 19.616 14.0545 18.736V17.9066"
                                                                        [ngClass]="entity?.monotainerAlerts ? 'bell-active' : 'bell-inactive'"
                                                                        stroke-width="1.55926" stroke-linecap="round"
                                                                        stroke-linejoin="round" />
                                                                </svg>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="plano-pop-up-details">
                                                        <div class="d-flex plan-cont-hover">
                                                            <div>TagID :</div>
                                                            <div>{{entity?.tagId}}</div>
                                                        </div>
                                                        <div class="d-flex  plan-cont-hover">
                                                            <div>Tagged Time :</div>
                                                            <div>{{entity?.taggedTime | date:'hh:mm aaa':'en-US'}}</div>
                                                        </div>
                                                        <div class="d-flex  plan-cont-hover">
                                                            <div>Destination :</div>
                                                            <div>{{entity?.destination}}</div>
                                                        </div>
                                                        <div class="d-flex  plan-cont-hover">
                                                            <div>Lane Id :</div>
                                                            <div class="zone-name">
                                                                <div *ngFor="let zone of entity?.zones; let i=index">
                                                                    {{zone?.name}}
                                                                    <span
                                                                        *ngIf="i>0 && i < lane?.monotainers?.zones?.lenght-1">,</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex  plan-cont-hover">
                                                            <div>TAT :</div>
                                                            <div>{{entity?.tat}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="plano-timings">
                                                        <div class="border-right ">
                                                            <div class="plan-cont-hover">First Seen</div>
                                                            <div class="">{{entity?.firstSeen | date:'hh:mm
                                                                aaa':'en-US'}}</div>
                                                        </div>
                                                        <div class="border-right ">
                                                            <div class="plan-cont-hover">Entry Time</div>
                                                            <div class="">{{entity?.entryTime | date:'hh:mm
                                                                aaa':'en-US'}}</div>
                                                        </div>
                                                        <div>
                                                            <div class=" plan-cont-hover">Last Seen</div>
                                                            <div class="">{{entity?.lastSeen | date:'hh:mm
                                                                aaa':'en-US'}}</div>
                                                        </div>

                                                    </div>


                                                </div>
                                            </mat-menu>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!data.length">
                                <div class="no-data-label">{{getNoDataLabel(lane)}}</div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div *ngIf="!lane?.monotainers?.length" class="justify-content-center d-flex">No monotainers in this lane
            </div>
        </div>
    </div>
</div>
<div *ngIf="!masterPlanogramData.length" class="no-records">
    <div class="d-flex justify-content-center align-items-center vh-75">
        <div class="text-center image-style">
            <img src="../../../assets/images/nodata.svg" class="w-10" alt="no-data">
        </div>
    </div>
</div>